<div class="app-modal-title">
	Select layers from {{fgdb}}
</div>
<div class="app-modal-content">
	<div>
		<div *ngFor="let layer of layers; let idx = index;" class="layer-item" (click)="onClickLayer(idx)">
			<div>{{layer.name}}</div>
			<input name="layer-{{idx}}" type="checkbox" [(ngModel)]="layer.selected">
		</div>
	</div>
	<!-- <select name="select-layers" size="10" multiple [(ngModel)]="selectedLayers">
		<option *ngFor="let layer of layers">
			{{layer}}
		</option>
	</select> -->
</div>
<div class="app-modal-footer">
	<div class="button-group">
		<button class="button-general" md-raised-button (click)="close('cancel')">Cancel</button>
		<button class="button-general" md-raised-button (click)="close('ok')" [disabled]="!enableOk">Ok</button>
	</div>
</div>